import {
  Component,
  Input,
  Output,
  EventEmitter,
  ElementRef,
  ViewChild,
  AfterViewInit,
  HostListener
} from '@angular/core';
import { IVideo } from 'src/app/modules/contents/videos-and-events/interfaces/videosByCategory';
import {
  IDateLabel,
  VideoDateLabelFormatterService
} from 'src/app/modules/contents/videos-and-events/services/video-date-label-formatter/video-date-label-formatter.service';
import { VideoModalHandlerService } from 'src/app/modules/contents/videos-and-events/services/video-modal-handler/video-modal-handler.service';

@Component({
  selector: 'app-video-list-card',
  templateUrl: './video-list-card.component.html',
  styleUrls: ['./video-list-card.component.scss']
})
export class VideoListCardComponent implements AfterViewInit {
  @Input() video: IVideo;
  @Input() bgTheme: 'dark' | 'light' = 'light';
  @ViewChild('videoImage') videoImage: ElementRef;
  @Output() imageHeightChanged = new EventEmitter<number>();

  imageHeight: number = 0;
  isMobile: boolean = window.innerWidth <= 900;

  constructor(
    private videoDateLabelFormatterService: VideoDateLabelFormatterService,
    private videoModalHandlerService: VideoModalHandlerService
  ) {}

  @HostListener('window:resize')
  onResize() {
    this.isMobile = window.innerWidth <= 900;
    if (this.videoImage?.nativeElement) {
      this.onImageLoad(this.videoImage.nativeElement);
    }
  }

  ngAfterViewInit() {
    if (this.videoImage.nativeElement.complete) {
      this.onImageLoad(this.videoImage.nativeElement);
    }
  }

  onImageLoad(img: HTMLImageElement) {
    this.imageHeight = img.offsetHeight;
    this.imageHeightChanged.emit(this.imageHeight);
  }

  formatDateLabel(video: IVideo): IDateLabel {
    return this.videoDateLabelFormatterService.formatDateLabel(video);
  }

  openVideoModal() {
    this.videoModalHandlerService.openVideoModal(this.video, false);
  }
}
